import { Auth } from 'aws-amplify';
import { SignUp } from 'aws-amplify-react';
import React from 'react';
import Button from '../Button';
import ContainerDefault from '../Container';
import Form from '../Form';
import Row from '../Row';
import Section from '../Section';
import Explanation from './Explanation';

const Container = ContainerDefault.extend`
    max-width: 20rem;
    position: relative;
`;

const help = {
    Mobile: {
        head: 'Mobile Phone',
        text: 'Make sure you enter a mobile phone number where you can receive SMS messages. We will send you verification codes which you have to enter later. Be sure to enter the international format for your phone number. This phone number will be used for two-factor authentication only.'
    },
    email: {
        head: 'Email',
        text: 'We also need a valid email address. Use the address with which you received the invitation.'
    },
    password: {
        head: 'Password',
        text: 'The password must comply with the following rules:',
        bullets: [
            '8 or more characters',
            'contains numbers',
            'contains lowercase letters',
            'contains uppercase letters'
        ]
    }
};

export default class CustomSignUp extends SignUp {
    constructor(props) {
        super(props);
        this.state = { help: undefined };
        this.onFocus = this.onFocus.bind(this);
    }

    public signUp() {
        const { given_name, family_name, password, email, phone_number } = this.inputs;
        Auth.signUp({ username: email, password, attributes: { given_name, family_name, phone_number } })
            .then(() => this.changeState('confirmSignUp', email))
            .catch(err => this.error(err));
    }

    private onFocus(element: string) {
        const elementHelp = help[element];
        this.setState({ help: elementHelp });
    }

    public render() {
        const { authState } = this.props;

        if (authState !== 'signUp') {
            return null;
        }

        return (
            <Section>
                <Container>
                    <Form>
                        <h3>Sign Up</h3>
                        <input
                            placeholder="First name"
                            key="given_name"
                            name="given_name"
                            onChange={this.handleInputChange}
                            onFocus={() => this.onFocus('FirstName')}
                        />
                        <input
                            placeholder="Family name"
                            key="family_name"
                            name="family_name"
                            onChange={this.handleInputChange}
                            onFocus={() => this.onFocus('FamilyName')}
                        />
                        <input
                            placeholder="Mobile phone (format +12345678900)"
                            key="phone_number"
                            name="phone_number"
                            onChange={this.handleInputChange}
                            onFocus={() => this.onFocus('Mobile')}
                        />
                        <input
                            placeholder="Email"
                            key="email"
                            name="email"
                            onChange={this.handleInputChange}
                            onFocus={() => this.onFocus('email')}
                        />
                        <input
                            placeholder="Password"
                            type="password"
                            key="password"
                            name="password"
                            onChange={this.handleInputChange}
                            onFocus={() => this.onFocus('password')}
                        />
                        <Button onClick={this.signUp}>Sign Up</Button>
                    </Form>
                    <Row>
                        <Button normal onClick={() => this.changeState('confirmSignUp', undefined)}>
                            Confirm a Code
                        </Button>
                        <Button normal onClick={() => this.changeState('signIn', undefined)}>
                            Sign In
                        </Button>
                    </Row>
                    <Explanation help={this.state.help} />
                </Container>
            </Section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/cognito/CustomSignUp.tsx